import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import GrabBagByStyle from './GrabBagByStyle.vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

interface RootProps {
  recaptchaSiteKey: string;
  culture: string;
}
declare const rootProps: RootProps;

const i18n = createAgonI18n(rootProps['culture']);

createApp(GrabBagByStyle, rootProps as never)
  .use(i18n)
  .use(VueReCaptcha, { siteKey: rootProps.recaptchaSiteKey })
  .mount('#app');
